export enum SubscriptionStepStatus {
  NONE = 'NONE',
  VALID = 'VALID',
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  WAITING = 'WAITING',
}
